import React, { useEffect } from "react";
import { createPortal } from "react-dom";

export default function WhatsNew({ open, canShowSeries = false, onShow, onDismiss }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onDismiss?.();
      }
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [open, onDismiss]);

  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/70 backdrop-blur-[2px] p-4"
      data-testid="whats-new"
      aria-live="polite"
      role="dialog"
      aria-modal="true"
      aria-labelledby="whats-new-title"
    >
      <div
        className="w-full max-w-[440px] border-2 border-[var(--phosphor)] bg-black p-5 text-[var(--phosphor)] shadow-[0_0_28px_color-mix(in_srgb,var(--phosphor)_42%,transparent)]"
        style={{ fontFamily: "JetBrains Mono, monospace" }}
      >
        <div className="mb-2 text-[10px] tracking-[0.28em] opacity-60">WHAT'S NEW</div>
        <div id="whats-new-title" className="mb-3 text-[24px] tracking-[0.12em]" style={{ fontFamily: "VT323, monospace" }}>
          SERIES INFORMATION
        </div>
        <div className="mb-5 text-[11px] leading-relaxed text-neutral-200">
          While watching a TV series, press <span className="text-[var(--phosphor)]">I</span> to open
          Series Information and browse every season and episode without leaving the television experience.
        </div>
        <div className="flex items-center justify-end gap-2">
          <button type="button" onClick={() => onDismiss?.()} className="border border-neutral-700 px-3 py-2 text-[10px] tracking-[0.18em] hover:border-[var(--phosphor)]" data-testid="whats-new-dismiss">
            GOT IT
          </button>
          {canShowSeries && (
            <button type="button" onClick={() => onShow?.()} className="border border-[var(--phosphor)] px-3 py-2 text-[10px] tracking-[0.18em] hover:bg-[var(--phosphor)] hover:text-black" data-testid="whats-new-show-me">
              SHOW ME ▶
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
